import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-logout-confirmation-dialog',
  template: `
    <nb-card>
      <nb-card-header>{{ 'tytul.wylogowanie' | translate }}</nb-card-header>
      <nb-card-body>
        <p>{{ 'komunikat.potwierdz-wylogowanie' | translate }}</p>
      </nb-card-body>
      <nb-card-footer>
        <button nbButton status="basic" (click)="dismiss()">
          {{ 'akcja.nie' | translate }}
        </button>
        <button nbButton status="danger" (click)="confirm()" class="ml-2">
          {{ 'akcja.tak' | translate }}
        </button>
      </nb-card-footer>
    </nb-card>
  `,
  styles: [`
    nb-card {
      max-width: 400px;
    }
    
    .ml-2 {
      margin-left: 0.5rem;
    }
  `]
})
export class LogoutConfirmationDialogComponent {

  constructor(private dialogRef: NbDialogRef<LogoutConfirmationDialogComponent>) {}

  dismiss() {
    this.dialogRef.close(false);
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
